const handler = ( $ ) => {
	const $copyableLink = $( '[data-copyable-link]' );

	if ( $copyableLink.length == 0 ) {
		return;
	}

	$( '.copy-done' ).hide();

	const copyLink = function ( e ) {
		e.preventDefault();

		const $link = $( this );

		navigator.clipboard.writeText( $link.attr( 'href' ) );

		const $copyDone = $( '.copy-done', $link );
		const $copyText = $( '.copy-text', $link );

		$copyText.hide();
		$copyDone.show();

		setTimeout( () => {
			$copyDone.hide();
			$copyText.show();
		}, 2000 );
	};

	$copyableLink.on( 'click', copyLink );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
